export interface IFeatureManagement {
  quoting: boolean;
  isLoaded: boolean;
}

export default class FeatureManagement implements IFeatureManagement {
  public quoting: boolean = false;
  public isLoaded: boolean = false;

  constructor(args?: Partial<IFeatureManagement>) {
    if (args) {
      Object.assign(this, { quoting: false, isLoaded: false }, args);
    }
  }

  /**
   * Deserialize an object to create a FeatureManagement instance.
   * @param input
   * @returns
   */
  static deserialize(input: Object): FeatureManagement {
    return new FeatureManagement(input as Partial<IFeatureManagement>);
  }

  /**
   * Get the keys of the FeatureManagement instance, excluding 'isLoaded'.
   * @returns Array of keys excluding 'isLoaded'.
   */
  static getKeys(instance?: FeatureManagement): Array<keyof FeatureManagement> {
    instance ??= new FeatureManagement();
    return Object.keys(instance).filter((key) => key !== 'isLoaded') as Array<
      keyof FeatureManagement
    >;
  }
}
